import { CommonModule, NgIf, NgSwitch, NgSwitchCase } from '@angular/common';
import { Component, HostListener, inject, Inject, OnChanges, signal, SimpleChanges } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { LabelsFilterComponent } from "../filters/labels-filter/labels-filter.component";
import { CommentsFilterComponent } from "../filters/comments-filter/comments-filter.component";
import { StarsFilterComponent } from "../filters/stars-filter/stars-filter.component";
import { ResidenceFilterComponent } from "../filters/residence-filter/residence-filter.component";
import { PriceFilterComponent } from "../filters/price-filter/price-filter.component";
import { TypeOfLocationComponent } from "../filters/type-of-location/type-of-location.component";
import { AccommodationFacilitiesComponent } from "../filters/accommodation-facilities/accommodation-facilities.component";
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FilterModel } from '@core/models/domains/filters.model';
import { ActivatedRoute, Router } from '@angular/router';
import { SearchResultUiService } from '../../services/search-result-ui.service';

@Component({
 selector: 'iho-filters-dialog',
 templateUrl: './filters-dialog.component.html',
 styleUrls: ['./filters-dialog.component.scss'],
 imports: [
    MatExpansionModule,
    LabelsFilterComponent,
    CommentsFilterComponent,
    StarsFilterComponent,
    ResidenceFilterComponent,
    PriceFilterComponent,
    TypeOfLocationComponent,
    CommonModule,
    AccommodationFacilitiesComponent
],
 standalone: true
})
export class FiltersDialogComponent implements OnChanges {
   route = inject(ActivatedRoute);
   router = inject(Router);
   searchUiService = inject(SearchResultUiService);
   activeFilters: Record<string, string> = {};
   showRemoveBtn = false;
   filterLabelsEcologe: string[] = [
    'labelsAccomodate',
    'facilities',
    'hotelStyles',
    'hotelTypes',
    'minPrice',
    'maxPrice',
  ];
   nullFilters = {
      minPrice: null,
      maxPrice: null,
      labels: null,
      types: null,
      grades: null,
      reviews: null,
      labelsAccomodate: null,
      hotelTypes: null,
      hotelStyles: null,
      facilities: null,
    };
    showPriceFilter = signal(true);
    minPrice = '';
    maxPrice = '';
    reset = signal(false);
    minPriceFilterInit!: number | string | undefined;
    maxPriceFilterInit!: number | string | undefined;
    expandedIndex = -1
    
    

   constructor(
      @Inject(MAT_DIALOG_DATA) public data: { dataSource: FilterModel[], expandedIndex: number },
      public dialogRef: MatDialogRef<FiltersDialogComponent>
 ) {
   this.minPriceFilterInit = +this.route.snapshot.queryParams['minPrice'];
   this.maxPriceFilterInit = +this.route.snapshot.queryParams['maxPrice'];
   this.expandedIndex = data.expandedIndex
   this.countFilters()
   
 }


   ngOnChanges(changes: SimpleChanges): void {
   }

   countFilters() {
   const params = this.route.snapshot.queryParams;

   Object.entries(params).forEach((param: any) => {
       this.filterLabelsEcologe.forEach((label) => {
         if (param[0] == label && param[1].length){
           this.showRemoveBtn = true;
         }
          
       });
   });
   
 }




   checkedItemsEmit(obj: any){
      switch (obj.key) {
         case 'types':
         //   this.types = obj.value;
           this.getDataForFilters(obj.value, 'hotelTypes');
           break;
         case 'hotelStyles':
         //   this.location = obj.value;
           this.getDataForFilters(obj.value, 'hotelStyles');
           break;
         case 'labels':
         //   this.labels = obj.value;
           this.getDataForFilters(obj.value, 'labelsAccomodate' );
           break;
         case 'reviews':
         //   this.reviews = obj.value;
           this.getDataForFilters(obj.value, 'reviews');
           break;
         case 'grades':
         //   this.grades = obj.value;
           this.getDataForFilters(obj.value, 'grades');
           break;
         case 'facilities':
         //   this.facilities = obj.value;
           this.getDataForFilters(obj.value, 'facilities');
           break;
       }
      
   }


   getDataForFilters(val: any, typeFilter: string) {
     
     const _value = (typeFilter === 'maxPrice' || typeFilter === 'minPrice') ? val.toString() : [...new Set(val)].toString()
     this.activeFilters = {
       ...this.activeFilters,
       // page: 1,
       [typeFilter]: _value,
      };
    //  this.showRemoveBtn = true;
    }



    setFilters(action = 'set') {
      const currentParams = { ...this.route.snapshot.queryParams, ...this.activeFilters };
      
      // remove duplicates
      for (let key in currentParams) {
        if (typeof currentParams[key] === 'string' && key !=='minPrice' && key !=='maxPrice') {
          const unique = [...new Set(currentParams[key].split(','))];
          
          currentParams[key] = unique.join(',');
        }
      }

      
      delete currentParams['page'];
      this.searchUiService.resetPlpResults();
      if (Object.keys(this.activeFilters).length) {
        this.router.navigate([], {
          queryParams: currentParams,
          relativeTo: this.route,
          // queryParamsHandling: 'merge',
        });
      } else if (action == 'removeAll') {
        this.router.navigate([], {
          queryParams: this.nullFilters,
          relativeTo: this.route,
      //    queryParamsHandling: 'merge',
        });
      }
      this.dialogRef.close(currentParams)
      
    }

    MinValue(ev: any) {
      this.minPrice = ev;
      this.getDataForFilters(ev, 'minPrice');
    }
  
    MaxValue(ev: any) {
      this.maxPrice = ev;
      this.getDataForFilters(ev, 'maxPrice');
    }

    removeAllFilters() {
      this.activeFilters = {};
      this.setFilters('removeAll');
      this.showPriceFilter.set(false);
      this.minPriceFilterInit = undefined;
      this.maxPriceFilterInit = undefined;
   }

   get activeFiltersLength() {
    return Object.keys(this.activeFilters).length
   }

   @HostListener('document:keydown.enter', ['$event'])
    handleEnter(event: KeyboardEvent) {
     this.setFilters()
     
    }

}
